import "./gui/styles/main.scss";
import "./gui/components/app";

import { Engine, Color, DisplayMode } from "excalibur";
import { loader } from "./loader";
import SocketManager from "./managers/socket-manager";
import Dashboard from "./gui/components/dashboard";
import { loadResource } from "./utils/resource";

class GameApp {
  public game: Engine;
  public wsClient: SocketManager;
  dashboard: Dashboard | null = null;

  constructor() {
    this.game = new Engine({
      displayMode: DisplayMode.FillScreen,
      pixelArt: true,
      backgroundColor: Color.Black,
      canvasElementId: "game",
      maxFps: 60,
      fixedUpdateFps: 60,
      suppressConsoleBootMessage: true,
    });

    const options = {
      maxReconnectionDelay: 10000,
      minReconnectionDelay: 1000,
      reconnectionDelayGrowFactor: 1.5,
      maxReconnectionAttempts: 5,
    };

    this.wsClient = new SocketManager(
      `${process.env.BASE_SOCKET_URL}`,
      options
    );
  }

  public setCameraZoom(zoom: number): void {
    this.game.currentScene.camera.zoom = zoom;
  }

  public showDashboard(): void {
    this.dashboard = new Dashboard();
    this.dashboard.displayGameUI();
  }

  public async startGame(): Promise<void> {
    await this.game.start(loader).catch(console.error);
  }
}

const gameApp = new GameApp();
export default gameApp;
